import BaseHeader from './BaseHeader';

const Head = props => <BaseHeader {...props} Element="thead" />;

export default Head;
